import config from "./sites.json";
const sites = config.sites;
export const getSite = (brand, locale) => sites[brand][locale];